import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import InputText from '../InputText';

type Props = {
  notaryName: string;
  notaryProtocol: string;
  notaryCity: string;
  onChangeName: (value: string) => void; // eslint-disable-line
  onChangeProtocol: (value: string) => void; // eslint-disable-line
  onChangeCity: (value: string) => void; // eslint-disable-line
  lgSize?: boolean;
};

const NotarySection: FC<Props> = ({
  notaryName,
  notaryProtocol,
  notaryCity,
  onChangeName,
  onChangeProtocol,
  onChangeCity,
  lgSize = false,
}) => {
  const { t } = useTranslate();
  return (
    <>
      <div className="col-4">
        <InputText
          id="notary-name"
          placeholder="Mr. John Smith"
          value={notaryName}
          label={t('NotaryName')}
          onChange={onChangeName}
          lgSize={lgSize}
        />
      </div>

      <div className="col-4">
        <InputText
          id="notary-protocol"
          placeholder="P-8234290A"
          value={notaryProtocol}
          label={t('NotaryProtocolNumber')}
          onChange={onChangeProtocol}
          lgSize={lgSize}
        />
      </div>

      <div className="col-4">
        <InputText
          id="notary-city"
          placeholder="Barcelona"
          value={notaryCity}
          label={t('NotaryCity')}
          onChange={onChangeCity}
          lgSize={lgSize}
        />
      </div>
    </>
  );
};

export default NotarySection;
